/**
 * Drawer Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import HotKeys from 'react-hot-keys';

import Button from '../../../atoms/buttons/Button';
import { LogoBopper } from '../../../atoms/images/Icon';

interface IOwnProps {
  actionButton?: React.ReactNode;
  className?: string;
  closeButtonLabel?: string;
  floatingHeader?: boolean;
  forwardedRef: React.Ref<HTMLDivElement>;
  headerIcon?: JSX.Element | null;
  closeButtonIcon?: JSX.Element | null;
  open?: boolean;
  position?: DrawerPosition;
  showCloseButton?: boolean;
  onRequestClose?(fromInside: boolean): void;
  onClose?(fromInside: boolean): void;
}

interface IOwnState {
  willClose: boolean;
}

export type DrawerProps = IOwnProps;

const classes = new BEM('drawer');

class Drawer extends React.Component<DrawerProps, IOwnState> {
  static defaultProps: Partial<IOwnProps> = {
    closeButtonLabel: 'Close',
    headerIcon: <LogoBopper />,
    position: 'left',
    showCloseButton: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      willClose: false,
    };
  }

  componentDidUpdate(prevProps: IOwnProps) {
    if (prevProps.open && !this.props.open) {
      this.onRequestClose(false);
    }
  }

  onClickDrawer: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
  }

  onClickClose = () => {
    this.onRequestClose(true);
  }

  onRequestClose = (fromInside: boolean) => {
    this.setState({ willClose: true }, () => {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(fromInside);
      }
      setTimeout(() => {
        if (this.props.onClose) {
          this.props.onClose(fromInside);
        }
      }, 300);
    });
  }

  render() {
    const {
      actionButton,
      children,
      className,
      closeButtonLabel,
      floatingHeader,
      forwardedRef,
      headerIcon,
      position,
      showCloseButton,
    } = this.props;

    const {
      willClose,
    } = this.state;

    const wrapperClassesModifiers = {
      [position!]: true,
    };

    const wrapperExtraClasses = classNames(
      { 'is-closing': willClose },
      className,
    );

    return (
      <HotKeys keyName="esc" onKeyDown={this.onClickClose} className="hotkeys">
        <div
          ref={forwardedRef}
          onClick={this.onClickDrawer}
          {...classes('', wrapperClassesModifiers, wrapperExtraClasses)}
        >
          <div {...classes('background') } />
          <div {...classes('header', { floating: !!floatingHeader }) }>
            {headerIcon}
            {actionButton}
            {showCloseButton && (
              <Button
                {...classes('close-button') }
                onClick={this.onClickClose}
                label={closeButtonLabel}
                icon={this.props.closeButtonIcon}
                variant={this.props.closeButtonIcon ? 'icon-no-padding' : 'text'}
              />
            )}
          </div>
          <div {...classes('content') }>
            {children}
          </div>
        </div>
      </HotKeys>
    );
  }
}

export default React.forwardRef<HTMLDivElement, Omit<DrawerProps, 'forwardedRef'>>((props, ref) => (
  <Drawer {...props} forwardedRef={ref} />
));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/modals/Drawer/index.tsx